import React from 'react'

function Response(props) {
  const {response} = props
  return (
    <div>
     {response ? 
      <pre style={{padding:'5px',wordBreak:'break-all',width:'50vw',height:"100%"}}>{JSON.stringify(response,null,2)}</pre> :
      <span className='noFiles'>Click Send Button to make an API call</span>
     }
    </div>
  )
}

export default Response